
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class Merchant extends Vue {
  public formTitle = 'مدیریت گروه ها';
  public desserts = [];
  public companies = [];
  public groups = [];
  public multiGroupItems = [];
  public dialog = false;
  public multiGroupChargeDialog = false;
  public multiGroupPackageDialog = false;
  public depositDialog = false;
  public chargeDialog = false;
  public packageDialog = false;
  public editDialog = false;
  public formDeleteTitle = 'آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟';
  public dialogDelete = false;
  public chargeProducts = [];
  public packageProducts = [];
  public phoneNumbers: any = [];
  public editedIndex = -1;
  public companyId = 0;
  public groupId = 0;
  public headers = [
    { text: 'نام', value: 'name' },
    { text: 'شرکت', value: 'company' },
    { text: 'اعتبار', value: 'credit' },
    { text: 'تعداد سیمکارت', value: 'totalSimCount' },
    { text: 'حد آلارم کیف پول', value: 'walletLimit' },
    { text: 'خرید خودکار شارژ', value: 'chargeAutoStatus' },
    { text: 'خرید خودکار بسته', value: 'packageAutoStatus' },
    { text: 'نوع بررسی', value: 'checkModeTitle' },
    { text: 'اجرای بعدی', value: 'nextRunAt' },
    { text: 'وضعیت', value: 'isDisabled' },
    { text: 'عملیات', value: 'action', sortable: false }
  ];
  public editedItem = {
    id: 0,
    name: '',
    companyId: 0
  };
  public defaultItem = {
    id: 0,
    name: '',
    companyId: 0
  };
  public transferItem = {
    id: 0,
    amount: 0,
    description: ''
  };
  public defaultTransferItem = {
    id: 0,
    amount: 0,
    description: ''
  };
  public chargeItem = {
    id: 0,
    amount: 0
  };
  public packageItem = {
    id: 0,
    packagePId: 0
  };
  public group = {
    id: 0,
    name: '',
    company: '',
    walletLimit: 0,
    chargeLimit: 0,
    packageLimit: 0,
    chargeProductId: 0,
    packageProductId: 0,
    phoneNotifyStatus: '',
    emailNotifyStatus: '',
    chargeAutoStatus: '',
    packageAutoStatus: '',
    phoneNotify: true,
    emailNotify: true,
    chargeAuto: true,
    packageAuto: true,
    credit: 0,
    isDisabled: '',
    checkMode: 0,
    checkTime: null as string | null,
    checkDayOfWeek: null as number | null,
    checkDayOfMonth: null as number | null,
    checkModeTitle: '',
    lastRunAt: null,
    nextRunAt: null,
  };
  public groupDefault = {
    id: 0,
    name: '',
    company: '',
    walletLimit: 0,
    chargeLimit: 0,
    packageLimit: 0,
    chargeProductId: 0,
    packageProductId: 0,
    phoneNotifyStatus: '',
    emailNotifyStatus: '',
    chargeAutoStatus: '',
    packageAutoStatus: '',
    phoneNotify: true,
    emailNotify: true,
    chargeAuto: true,
    packageAuto: true,
    credit: 0,
    isDisabled: '',
    checkMode: 0,
    checkTime: null as string | null,
    checkDayOfWeek: null as number | null,
    checkDayOfMonth: null as number | null,
    checkModeTitle: '',
    lastRunAt: null,
    nextRunAt: null,
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'مدیریت گروه ها',
      disabled: true,
      href: ''
    }
  ];

  public checkModes = [
    { text: 'مداوم', value: 0 },
    { text: 'روزانه', value: 1 },
    { text: 'هفتگی', value: 2 },
    { text: 'ماهانه', value: 3 }
  ];
  public weekDays = [
    { text: 'یکشنبه', value: 0 },
    { text: 'دوشنبه', value: 1 },
    { text: 'سه‌شنبه', value: 2 },
    { text: 'چهارشنبه', value: 3 },
    { text: 'پنجشنبه', value: 4 },
    { text: 'جمعه', value: 5 },
    { text: 'شنبه', value: 6 }
  ];
  public monthDays = [
    { text: 'آخر ماه', value: 0 },
    ...Array.from({ length: 31 }, (_, i) => ({ text: `${i + 1}`, value: i + 1 }))
  ];

  onCheckModeChange() {
  if (this.group.checkMode != 2) this.group.checkDayOfWeek = null;
  if (this.group.checkMode != 3) this.group.checkDayOfMonth = null;
  if (this.group.checkMode == 0) this.group.checkTime = null;
  }

  formatDate(value: string | null) {
    if (!value) return '-';
    return new Date(value).toLocaleString('fa-IR');
  }

  async created() {
    this.$showLoading();
    await Api.getCompanyShortList().then((response: any) => {
      this.companies = response.data;
    });
    await Api.getGroupShortList().then((response: any) => {
      this.groups = response.data;
    });
    await Api.getProducts(1).then((response: any) => {
      this.chargeProducts = response.data;
    });
    await Api.getProducts(2).then((response: any) => {
      this.packageProducts = response.data;
      this.$hideLoading();
    });

    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getGroups({ companyId: this.companyId, groupId: this.groupId }).then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async editGroup(id: number) {
    this.group.id = id;
    await Api.getGroup(id).then((response: any) => {
      this.group = Object.assign({}, response.data);
      if (this.group.checkTime) this.group.checkTime = this.group.checkTime.substring(0, 5);
      this.$hideLoading();
    });
    this.editDialog = true;
  }

  async editGroupItem() {
    const isValid = (this.$refs.Observer2 as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.editGroup({
      id: this.group.id,
      phoneNotify: this.group.phoneNotify,
      emailNotify: this.group.emailNotify,
      chargeAuto: this.group.chargeAuto,
      packageAuto: this.group.packageAuto,
      walletLimit: this.group.walletLimit,
      chargeLimit: this.group.chargeLimit,
      packageLimit: this.group.packageLimit,
      chargeProductId: this.group.chargeProductId,
      packageProductId: this.group.packageProductId,
      checkMode: this.group.checkMode,
      checkTime: this.group.checkTime ? this.group.checkTime + ':00' : null,
      checkDayOfWeek: this.group.checkDayOfWeek,
      checkDayOfMonth: this.group.checkDayOfMonth
    }).then((response: any) => {
      this.close();
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد');
      this.$hideLoading();
    });
  }

  toggleMultiChargeGroupItem(item: any) {
    if (!this.multiGroupItems.some((s) => s.id == item.id)) this.multiGroupItems = [...this.multiGroupItems, item];
    else this.multiGroupItems = this.multiGroupItems.filter((f) => f.id != item.id);
  }

  editItem(item: any) {
    this.editedIndex = this.desserts.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    if (this.editedIndex > -1) {
      await Api.editGroup(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Record Updated');
        this.$hideLoading();
      });
    } else {
      await Api.createGroup(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Record Created');
        this.$hideLoading();
      });
    }
  }

  async enableItem(id: number) {
    await Api.enableGroup(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'شرکت فعال شد');
      this.$hideLoading();
    });
  }

  async disableItem(id: number) {
    await Api.disableGroups(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'شرکت غیرفعال شد');
      this.$hideLoading();
    });
  }

  chargeGroup(id: number) {
    this.chargeItem.id = id;
    this.chargeDialog = true;
  }

  chargeGroupSelectedItem(id: number) {
    this.chargeDialog = true;
    this.multiGroupChargeDialog = true;
    this.chargeItem.id = id;
  }

  packageGroupSelectedItem(id: number) {
    this.packageDialog = true;
    this.multiGroupPackageDialog = true;
    this.packageItem.id = id;
  }

  packageGroup(id: number) {
    this.packageItem.id = id;
    this.packageDialog = true;
  }

  handleFileUpload(file) {
    if (!file) {
      this.phoneNumbers = [];
      return;
    }
    if (file.type != 'text/csv') {
      this.$showNotification('error', 'فقط فایل با فورمت csv مورد تایید است.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const csvData = event.target.result as string;
      this.phoneNumbers = csvData.split('\r\n');
      // Papa.parse(csvData, {
      //   header: true,
      //   complete: (results) => {
      //     this.phoneNumbers = results.data.map((row) => row['شماره تلفن']);
      //   }
      // });
    };
    reader.readAsText(file);
  }

  async chargeGroupConfirm() {
    this.$showLoading();
    await Api.chargeGroup(this.chargeItem.id, this.chargeItem.amount).then((response: any) => {
      this.$showNotification('success', 'شارژ با موفقیت ثبت شد');
      this.close();
      this.$hideLoading();
    });
  }

  async multiChargeGroupConfirm() {
    if (this.phoneNumbers.length == 0) {
      this.close();
    } else {
      this.$showLoading();
      await Api.chargeGroupList(this.chargeItem.id, this.chargeItem.amount, this.phoneNumbers).then(() => {
        this.$showNotification('success', 'شارژ با موفقیت ثبت شد');
        this.phoneNumbers = [];
        this.$hideLoading();
        this.close();
      });
    }
  }

  async packageGroupConfirm() {
    this.$showLoading();
    await Api.packageGroup(this.packageItem.id, this.group.packageProductId).then((response: any) => {
      this.$showNotification('success', 'بسته با موفقیت ثبت شد');
      this.close();
      this.$hideLoading();
    });
  }

  async multiPackageGroupConfirm() {
    if (this.phoneNumbers.length == 0) {
      this.close();
    } else {
      this.$showLoading();
      await Api.packageGroupList(this.packageItem.id, this.group.packageProductId, this.phoneNumbers).then(() => {
        this.$showNotification('success', 'بسته با موفقیت ثبت شد');
        this.phoneNumbers = [];
        this.$hideLoading();
        this.close();
      });
    }
  }

  deleteItem(id: number) {
    this.editedIndex = id;
    this.dialogDelete = true;
  }

  async deleteItemConfirm(id: number) {
    this.$showLoading();
    await Api.deletGroup(id).then((response: any) => {
      this.$showNotification('success', 'شارژ با موفقیت ثبت شد');
      this.close();
      this.$hideLoading();
    });
  }

  depositItem(id: number) {
    this.transferItem.id = id;
    this.depositDialog = true;
  }

  async depositWallet() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createGroupWalletDeposit(this.transferItem).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async detail(id: string) {
    this.$router.push({ name: 'GroupDetail', params: { id: id } });
  }

  async transaction(id: string) {
    this.$router.push({ name: 'GroupWallet', params: { id: id } });
  }

  async close() {
    this.dialog = false;
    this.dialogDelete = false;
    this.depositDialog = false;
    this.chargeDialog = false;
    this.multiGroupChargeDialog = false;
    this.packageDialog = false;
    this.editDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.transferItem = Object.assign({}, this.defaultTransferItem);
      this.editedIndex = -1;
    });
    this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(isDisabled: string) {
    if (isDisabled === 'فعال') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
